import React from 'react';
import Container from 'react-bootstrap/esm/Container';
import { StageTable } from '../Component/Stages/StageTable';
export const StagesPage = () => {
  return (
    <Container className="startpage">
      <StageTable />
    </Container>
  );
};
